import firebase from './init'
import { TagCondition } from '../services/tagsParser'

let tagsParsingAPI: { [key: string]: TagCondition[] } = {}

export const getTagsParsingAPI = () => tagsParsingAPI
export const subscribeToTagsParsingAPI = () => {
    firebase
        .database()
        .ref('extConfig')
        .on('value', res => {
            tagsParsingAPI = res.val()
        })
}

export const clearTagsParsingAPI = () => {
    tagsParsingAPI = {}
}
